import { Grid, TextField, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { FC, useState } from "react";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { ReactComponent as CalendarIcon } from "../../assets/icons/calendar-icon.svg";
import { Moment } from "moment";
import "./date.picker.component.css";
import moment from "moment";

interface IDatePickerComponent {
    value?: Moment | null;
    minDate?: Moment | null;
    maxDate?: Moment | null;
    title: string;
    width?: string;
    updateDate: (arg: Moment | null) => void;
}

const DatePickerComponent: FC<IDatePickerComponent> = (props: IDatePickerComponent) => {
    const [open, setOpen] = useState(false);
    return (
        <Grid className="datepicker-component">
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                    open={open}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    components={{
                        OpenPickerIcon: CalendarIcon,
                    }}
                    label={props.title}
                    toolbarFormat="DD/MM/YYYY"
                    inputFormat="DD/MM/YYYY"
                    minDate={props.minDate}
                    maxDate={props.maxDate}
                    value={props.value}
                    onChange={(newValue) => {
                        props.updateDate(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                    // open calendar on input click
                    // renderInput={(params) => <TextField {...params} onClick={() => setOpen(true)} />}
                />
                {/* <Typography>Value: {props.value == null ? "null" : props.value.format()}</Typography> */}
            </LocalizationProvider>
        </Grid>
    );
};

export default DatePickerComponent;
